export default function(name){
    return {
        name: name,
        props: {
            question: {
                type: Object,
                required: true
            },
            questionMap: {
                type: Object,
                required: true
            },
            survey: {
                type: Object,
                required: true
            },
            widgetRules: {
                type: Array,
                required: true
            },
            debug: {
                type: Boolean,
                required: false,
                default: false
            } 
        },
        created: function(){
            this.init();
        },
        data: function(){
            return {
                touch: false,
                display_buffer: {},
                triggerResults: {},
                triggered: {}
            }
        },
        methods: {
            init: function(){
                var self = this;
                for(let index in self.widgetRules){
                    let widget = self.widgetRules[index];
    
                    if(typeof self.triggerResults[widget.name]=='undefined'){
                        self.triggerResults[widget.name] = {};
                        self.triggered[widget.name] = false;
                    }
                }
                self.runTriggers();
            },
            runTriggers: function(){
                var self = this;
                self.touch = !self.touch;
                for(let index in self.widgetRules){
                    let widget = self.widgetRules[index];
                    let widget_name = widget.name;
                    let rules = widget.rules;
                    let output = {}
                    
                    if(self.$root.in_array(self.question.config.id,widget.display_target)){
                        for(let rule_name in rules){
                            let rule = rules[rule_name];
                            let conditions = rule.conditions;
                            output[rule.name] = {};
    
    
                            
                            for(let c=0; c<conditions.length; c++){
                                let condition = conditions[c];
                                let result = false;
                                
    
                                let ref_id = condition.ref_id;
                                let group_id = condition.group_id;
                                let question = (ref_id && group_id) ? self.questionMap[ref_id] : null;
    
                                let value = (question && question.value) ? question.value[condition.group_id] : null;
                                
                                if(value!=null){
    
                                    if(condition.equals!=null){
                                        result = typeof value=='object' ? self.$root.in_array(condition.equals, value) : condition.equals==value;
                                    }
    
                                    if(condition.contains!=null && condition.contains.length>0){
                                        let contains = JSON.parse(condition.contains);
                                        result = self.$root.in_array(value, contains);
                                    }
    
                                    output[rule.name][condition.name+'_basic'] = result;
    
                                }
    
                                if(typeof condition.advanced == 'function'){
                                    try {
                                        result = condition.advanced(question, self.questionMap, self.$language(), self);
                                    } catch (error) {
                                        console.error('WIDGET LOGIC - ADVACNED EXECUTION ERROR',{
                                            widget_name: widget_name,
                                            rule: rule.name,
                                            error: error
                                        })
                                    }
                                    output[rule.name][condition.name+'_advanced'] = result;
                                }
    
    
                                if(typeof condition.watcher == 'function'){
                                    try {
                                        result = condition.watcher(question, self.questionMap, self.$language(), self);
                                    } catch (error) {
                                        console.error('WIDGET LOGIC - WATCHER EXECUTION ERROR',{
                                            widget_name: widget_name,
                                            rule: rule.name,
                                            error: error
                                        })
                                    }
                                    output[rule.name][condition.name+'_watcher'] = result;
                                }
    
                                if(result===true){
                                    self.triggered[widget_name] = true;
                                }
                            }
    
    
                        }
    
                        self.triggerResults[widget_name] = output;
                    }
    
                }
                setTimeout(function(){
                    self.touch = !self.touch;
                },0)
            },
            logTrigger: function(widget_name, before, after, data){
                if(before!=after && after===true){
                    this.$emit('log',data);
                }
            },
            widgetRequest: function(data){
                this.$emit('widgetRequest',data);
            }
        },
        computed: {
            qid: function(){
                return this.question.config.id
            },
            answers: function(){
                return this.survey.answers;
            }
        },
        watch: {
            answers: {
                deep: true,
                handler: function(){
                    this.runTriggers();
                }
            }
        }
    }
}